import { React } from 'react';
import Loader from '../Loader/Loader';
import LinkMore from '../LinkMore/LinkMore';

const Teasers = ({ isFetching, teasers, categoryId }) => {
    if (isFetching) {
        return <Loader spinner />;
    }

    const content = teasers.map((entry) => {
        const category = entry.categoryId ?? categoryId;
        if (!category) {
            return null;
        }

        return (
            <li key={entry.id} className="list-teasers__item" data-nr="entries-teasers">
                <h2 id={`headingId-${entry.id}`} className="list-teasers__name">{entry.name}</h2>
                <p className="list-teasers__lead">{entry.description}</p>
                <LinkMore
                    contentId={`${category}/${entry.id}`}
                    name={entry.name}
                    id={`linkId-${entry.id}`}
                    labelledBy={`linkId-${entry.id} headingId-${entry.id}`}
                />
            </li>
        );
    });

    return <ul className="list-teasers">{content}</ul>;
};

export default Teasers;
